import {Component, Input} from '@angular/core';
import { TeamGroupsService } from '../../../../services/teamGroups.service';
import { ErrorHandlerProvider } from '../../../../shared/providers/errorHandler.provider';
import {ToastsManager} from 'ng2-toastr';

@Component({
    selector: 'app-consultants-teamGroups-listing',
    templateUrl: './consultants-teamGroups-listing.component.html',
    styleUrls: ['./consultants-teamGroups-listing.component.css']
})
export class ConsultantsTeamGroupsComponentListing {
    @Input() TeamGroups: any;
    @Input() Limit: any;
    @Input() CurrentPage: any;
    @Input() TotalItems: any;

    constructor(
        private teamGroupsService: TeamGroupsService,
        private errorHandler: ErrorHandlerProvider,
        private toastr: ToastsManager
    ) {}

    async changeStatus(teamGroup) {
        let res = await this.teamGroupsService.update(teamGroup);

        if(res._id) {
            return this.toastr.success('Status do Grupo atualizado com sucesso', 'Grupos de Times');
        } else {
            this.errorHandler.interceptError(res, 'Grupo de Time');
        }
    }

    collapse(idToggle) {
        idToggle['expand'] = !idToggle['expand'];
    }
}



// WEBPACK FOOTER //
// ./src/app/views/consultants/consultants-teamGroups/consultants-teamGroups-listing/consultants-teamGroups-listing.component.ts